import { render, staticRenderFns } from "./DraftPreview.vue?vue&type=template&id=138909fc&scoped=true&"
import script from "./DraftPreview.vue?vue&type=script&lang=js&"
export * from "./DraftPreview.vue?vue&type=script&lang=js&"
import style0 from "./DraftPreview.vue?vue&type=style&index=0&id=138909fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138909fc",
  null
  
)

export default component.exports